import { NgModule, Type } from '@angular/core';

import { AddFilesUploadComponent } from './add-files-upload.component';
import { AttachmentFileViewCardModule } from '../attachment-file-view-card/attachment-file-view-card.module';
import { CommonModule } from '@angular/common';
import { FilesUploadModule } from '../files-upload/files-upload.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { IconAttachmentModule } from '../../atoms/icon-attachment/icon-attachment.module';
import { PipesModule } from 'frontend/admin/app/shared/pipes/pipes.module';

const components: Type<any>[] = [AddFilesUploadComponent];

@NgModule({
  imports: [CommonModule, FontAwesomeModule, FormsModule, PipesModule, FilesUploadModule, AttachmentFileViewCardModule, IconAttachmentModule],
  declarations: [components],
  exports: [components],
})
export class AddFilesUploadModule { }
